import SaveButton from "@/components/button/save-button";
import { ProfilePageContainer } from "@/components/container/profile-page-container";
import { SelectablePill } from "@/components/form/selectable-pill";
import { ListRenderer } from "@/components/list/list-renderer";
import { PageTitleComponent } from "@/components/page-title";
import { RecreatePlanAlert } from "@/features/settings/components/recreate-plan-alert";
import { useDietaryRequirement } from "@/hooks/features/use-dietary-requirement";
import { useToast } from "@/hooks/ui/use-toast";
import { IonSkeletonText, useIonRouter } from "@ionic/react";
import { useState } from "react";

export default function SettingFoodPreferenceDietaryRequirementPage() {
  const navigation = useIonRouter();
  const [isOpen, setIsOpen] = useState(false);
  const { showSuccess } = useToast();
  const {
    dietaryOptions,
    isLoadingOptions,
    selectedDietary,
    setSelectedDietary,
    handleSubmit,
    isUpdating,
  } = useDietaryRequirement(() => {
    setIsOpen(true);
  });

  const handleCancel = () => {
    setIsOpen(false);
    navigation.goBack();
  };

  const handleRecreatePlan = () => {
    setIsOpen(false);
    showSuccess("Recreate plan successful");
    navigation.goBack();
  };

  return (
    <ProfilePageContainer className="overflow-y-auto no-scrollbar pb-16">
      <PageTitleComponent
        title="Dietary Preferences / Requirements"
        description="Please select any dietary preferences or requirements you have from the list below."
        className="mt-2 mb-6 w-full"
      />

      <div className="w-full flex flex-col gap-8 flex-1">
        <ListRenderer
          items={dietaryOptions}
          isLoading={isLoadingOptions}
          emptyComponent={
            <div className="flex flex-col items-center justify-center text-sm text-gray-500">
              No dietary requirements options found
            </div>
          }
          loadingComponent={
            <div className="grid grid-cols-2 gap-4">
              {Array.from({ length: 20 }).map((_, index) => (
                <IonSkeletonText key={index} className="w-full h-10" animated />
              ))}
            </div>
          }
        >
          <div className="grid grid-cols-2 gap-4">
            {dietaryOptions?.map((option) => (
              <SelectablePill
                key={option}
                label={option}
                selected={selectedDietary.has(option)}
                onClick={() => {
                  if (selectedDietary.has(option)) {
                    setSelectedDietary((prev) => {
                      const next = new Set(prev);
                      next.delete(option);
                      return next;
                    });
                  } else {
                    setSelectedDietary((prev) => new Set(prev).add(option));
                  }
                }}
              />
            ))}
          </div>
        </ListRenderer>

        <SaveButton
          text="Save & Continue"
          onSave={handleSubmit}
          position="fixed"
          disabled={isUpdating}
        />
      </div>
      <RecreatePlanAlert
        isOpen={isOpen}
        onCancel={handleCancel}
        onConfirm={handleRecreatePlan}
      />
    </ProfilePageContainer>
  );
}
